/* eslint-disable import/no-anonymous-default-export */
import * as React from 'react';
import RateManagementPage from './RateManagementPage';

export default {
    list: RateManagementPage,
};
